import { Button, Container, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Swal from 'sweetalert2';
import { t } from 'i18next';
import { useSnackbar } from 'notistack';
import Iconify from '../../components/Iconify';
import { useLoadingContext } from '../../context/loadingContext';
import Page from '../../components/Page';
import { BannerService } from '../../Services/banner.service';
import BannerCard from '../../sections/@dashboard/banner/BannerCard';

const BannerPage = () => {
  const { handleStartLoading, handleStopLoading } = useLoadingContext();
  const { enqueueSnackbar } = useSnackbar();
  const [banner, setBanner] = useState([]);
  const [edit, setEdit] = useState(false);

  React.useEffect(() => {
    GetBanner().finally(handleStopLoading);
  }, []);

  const GetBanner = async () => {
    handleStartLoading();
    const adsData = await BannerService.GetBanner();
    setBanner(adsData);
  };

  const handleDisableBanner = React.useCallback(
    (id) => {
      handleStartLoading();
      BannerService.DisableBanner(id)
        .then(() => {
          const newData = banner.map((item) => {
            if (item._id === id) item.status = 'Inactive';
            return item;
          });
          setBanner(newData);
          enqueueSnackbar('Thành công', { variant: 'success' });
        })
        .catch((err) => enqueueSnackbar(err.response.data, { variant: 'error' }))
        .finally(handleStopLoading);
    },
    [banner]
  );

  const handleEnableBanner = React.useCallback(
    (id) => {
      handleStartLoading();
      BannerService.EnableBanner(id)
        .then(() => {
          const newData = banner.map((item) => {
            if (item._id === id) item.status = 'Active';
            return item;
          });
          setBanner(newData);
          enqueueSnackbar('Thành công', { variant: 'success' });
        })
        .catch((err) => enqueueSnackbar(err.response.data, { variant: 'error' }))
        .finally(handleStopLoading);
    },
    [banner]
  );

  const handleDeleteBanner = React.useCallback(
    (id) =>
      Swal.fire({
        customClass: {
          container: { zIndex: 999999 },
        },
        title: 'Xóa quảng cáo',
        text: 'Thao tác này không thể hoàn tác',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: t('sure.yes'),
        cancelButtonText: t('sure.no'),
      }).then((result) => {
        if (result.isConfirmed) {
          handleStartLoading();
          BannerService.DeleteBanner(id)
            .then(() => {
              const newData = banner.filter((bannerr) => bannerr._id !== id);
              setBanner(newData);
              enqueueSnackbar('Thành công', { variant: 'success' });
            })
            .catch((err) => enqueueSnackbar(err.response.data, { variant: 'error' }))
            .finally(handleStopLoading);
        }
      }),
    [banner]
  );

  const handleEdit = () => setEdit(true);

  const handleSttChange = (_id, stt) => {
    const temp = banner.map((item) => {
      if (item._id === _id) {
        item.stt = stt;
      }
      return item;
    });
    setBanner(temp);
  };

  const handleSaveClicked = () => {
    const newData = banner.map((item) => ({
      _id: item._id,
      stt: item.stt,
    }));
    BannerService.EditStt(newData)
      .then(() => {
        setEdit(false);
        enqueueSnackbar('Thành công', { variant: 'success' });
      })
      .then(GetBanner)
      .catch((err) => enqueueSnackbar(err.response.data, { variant: 'error' }))
      .finally(handleStopLoading);
  };

  return (
    <Page title={'Promotion'}>
      <Container maxWidth="lg">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Banner
          </Typography>

          <Stack spacing={1} direction="row">
            {!edit ? (
              <>
                <Button
                  variant="contained"
                  color="info"
                  onClick={handleEdit}
                  startIcon={<Iconify icon="material-symbols:edit" />}
                >
                  Cập nhật
                </Button>
                <Button
                  variant="contained"
                  component={RouterLink}
                  to="/banner/create"
                  startIcon={<Iconify icon="eva:plus-fill" />}
                >
                  Thêm banner
                </Button>
              </>
            ) : (
              <>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => setEdit(false)}
                  startIcon={<Iconify icon="material-symbols:cancel-outline" />}
                >
                  Hủy
                </Button>
                <Button
                  variant="contained"
                  onClick={handleSaveClicked}
                  startIcon={<Iconify icon="material-symbols:save" />}
                >
                  Lưu
                </Button>
              </>
            )}
          </Stack>
        </Stack>

        {banner.map((bannerr) => (
          <BannerCard
            key={bannerr._id}
            bannerr={bannerr}
            onDisable={handleDisableBanner}
            onEnable={handleEnableBanner}
            onDelete={handleDeleteBanner}
            edit={edit}
            handleSttChange={handleSttChange}
          />
        ))}
      </Container>
    </Page>
  );
};

export default BannerPage;
